<style lang="sass" scoped>
::v-deep
  .van-button--primary
    background-color: var(--menu-primary-background-colour) !important
</style>
<template lang="pug">
.survey
  marketing-dialog(
    v-model="showSurveys"
    :round="false"
    :style="'min-height: 100%'"
    @closeDialog="closeMarketingDialog"
  )
    template(v-slot:popup-dialog)
      // isCampaign = 3 force to load survey only
      marketing-campaigns(
        ref="marketingCampaigns"
        :img-src="logoImgSrc"
        :marketing-consent-message="marketingConsentMessage"
        :showSurveys="showSurveys"
        :data="campaignsList"
        :isCampaigns="3"
        :messageList="messageList"
        :fullScreen="true"
        :alwaysShowHeader="false"
        :bottomButtonStyle="'height:50px;'"
        @closeDialog="closeSurvey"
      )
</template>
<script>
import Vue from 'vue'
import Component, { mixins } from 'vue-class-component'
import mixin from '@/utils/mixin'
import { getUser } from '@/api/product'
import { mapState } from 'vuex'
import MarketingCampaigns from '@/views/pay/component/MarketingCampaigns'
import MarketingDialog from '@/views/pay/component/MarketingDialog'

@Component({

  watch: {
    $route(val) {
      this.routerName = val.name
    },
  },

  async created() {
    this.$store.commit('showLoading')
    this.routerName = this.$route.name
    this.getCampaignInfo()
    this.$store.commit('closeLoading')
  },

  components: {
    MarketingCampaigns,
    MarketingDialog
  },

  props: {
    userId: [String, Number],
    venueId: [String, Number],
    surveyId: [String, Number],
  },

  computed: {
    ...mapState(['paymentInfo', 'id']),
    ...mapState({
      isOnline: state => state.app.isOnline,
      venueAddress: state => state.venueHome.pickupSettings && state.venueHome.pickupSettings.pickupAddress && state.venueHome.pickupSettings.pickupAddress !== '' ? state.venueHome.pickupSettings.pickupAddress : state.venueHome.address,
      routerInfo: state => state.venueHome.routerInfo,
      postWidgetSettings: state => state.venueHome.postWidgetSettings,
    }),
  },
})

class Survey extends mixins(mixin) {
  showSurveys = false
  showPopupLoading = false
  campaignsList = []
  messageList = {}

  async getCampaignInfo() {
    const userId = this.userId
    const notificationKey = localStorage.getItem('notificationKey') || ''
    if (userId) {
      console.log(this.venueId)
      const res = await getUser({
        id: userId,
        notificationKey: notificationKey,
        venueId: this.venueId,
        surveyId: this.surveyId
      }).catch(error => {
        console.log(error)
        this.$store.commit('closeLoading')
        // this.jumpToIndex()
      })
      // console.log(res)
      if (res) {
        this.showSurveys = true
        this.campaignsList = res?.campaigns ?? []
        if (this.campaignsList[0] && this.campaignsList[0].logoTitle) {
          this.messageList.logo = this.campaignsList[0].logo ?? null
          this.messageList.title = this.campaignsList[0].logoTitle ?? ''
          this.messageList.titleLong = this.campaignsList[0].logoTitleLong ?? ''
        } else {
          this.messageList = {}
        }
      } else {
        // this.jumpToIndex()
      }
    }
  }

  // 关闭营销的弹窗
  closeMarketingDialog() {
    this.$refs.marketingCampaigns._closeAnswerCampaign()
    this.closeSurvey()
  }

  closeSurvey() {
    this.showSurveys = false
    this.jumpToIndex()
  }

  jumpToIndex() {
    // clearTimeout for canceling the showDialog
    clearTimeout(this.timer)
    const tableNumber = this.routerInfo.number || this.$route.query?.tableNumber
    if (tableNumber) {
      this.$router.push(`/v/${this.venueId}/home/t/${tableNumber}`)
    } else {
      if (this.routerInfo.noTable) {
        this.$router.push(`/v/${this.venueId}/home/t/${this.order.details.table}`)
      } else {
        this.$router.push(`/v/${this.venueId}/home/p`)
      }
    }
  }
}

export default Survey
</script>
